import React from 'react';
import Link from 'next/link';
import Swal from 'sweetalert2';
import { useRouter } from 'next/router';
import { ref, orderByChild, equalTo, query, get } from 'firebase/database';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useUser } from '../../hooks';
import { auth, database } from '../../lib/firebase';

export default function SignInForm() {
  const router = useRouter();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [, setUser] = useUser();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      const snapshot = await get(
        query(ref(database, 'users'), orderByChild('email'), equalTo(email))
      );
      if (snapshot.exists()) {
        const [key] = Object.keys(snapshot.val());
        setUser({
          firstName: snapshot.val()?.[key].first_name ?? '',
          secondName: snapshot.val()?.[key].second_name ?? '',
          firstLastname: snapshot.val()?.[key].first_lastname ?? '',
          secondLastname: snapshot.val()?.[key].second_lastname ?? '',
          phone: snapshot.val()?.[key].phone ?? '',
          email: snapshot.val()?.[key].email ?? '',
          answer: snapshot.val()?.[key].answer ?? '',
          profession: snapshot.val()?.[key].profession ?? '',
          dni: snapshot.val()?.[key].dni ?? '',
          id: snapshot.val()?.[key].id ?? '',
          idUser: snapshot.val()?.[key].id_user ?? '',
          points: snapshot.val()?.[key].points ?? '',
          refer: snapshot.val()?.[key].refer ?? '',
          birthdate: snapshot.val()?.[key].birthdate ?? '',
        });
        Swal.fire({
          icon: 'success',
        });
        await router.push('/products');
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Algun campo introducido esta erroneo',
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { name } = e.target;
    const { value } = e.target;
    if (name === 'email') {
      setEmail(value);
    } else {
      setPassword(value);
    }
  };
  return (
    <form method="POST" onSubmit={handleSubmit}>
      <div className="card" data-background="color" data-color="blue">
        <div className="card-header">
          <h3 className="card-title text-center">Iniciar sesión</h3>
        </div>
        <div className="card-content">
          <div className="form-group">
            <h6>Correo electrónico</h6>
            <input
              type="email"
              value={email}
              placeholder="Enter email"
              id="email"
              name="email"
              className="form-control input-no-border"
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <h6>Contraseña</h6>
            <input
              type="password"
              value={password}
              placeholder="Password"
              id="password"
              name="password"
              className="form-control input-no-border"
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="card-footer text-center py-3">
          <button type="submit" className="btn btn-fill btn-wd">
            Enviar
          </button>
          <div className="forgot py-1">
            <Link href="/forgot-password">Olvidaste tu contraseña?</Link>
          </div>
        </div>
      </div>
    </form>
  );
}
